module.exports = __webpack_public_path__ + "img/no-results.7f880ae8.svg";